import {ROUTES} from '../../../../_gori/constants/_routes'
import {SeoConfig} from './_models'

export const SEO_CONFIG: SeoConfig = {
  [ROUTES.LANDING.BASE]: {
    title: 'ShipBae',
    description:
      'Compare real-time carrier rates, print labels instantly, and reduce shipping costs with AI-powered multi-carrier shipping software.',
    keywords:
      'multi-carrier shipping software, shipping software for ecommerce, carrier rate comparison, shipping label software, AI shipping optimization',
  },
  [ROUTES.PRODUCTS.PRODUCT]: {
    title: 'Carrier Management & Multi-Carrier Shipping Platform | ShipBae',
    description:
      'Centralize carrier management, automate shipping workflows, and optimize parcel costs with real-time rate comparison.',
    keywords:
      'carrier management solutions, parcel shipping software, shipping rate comparison software, multi-carrier platform',
  },
  [ROUTES.PRODUCTS.INSURANCE]: {
    title: 'Shipment Protection & Delivery Monitoring Software | ShipBae',
    description:
      'Monitor deliveries, prevent lost packages, and reduce claims with proactive shipment visibility and tracking tools.',
    keywords:
      'shipment protection software, delivery monitoring, lost package prevention, shipment tracking solution',
  },
  [ROUTES.PRICING.BASE]: {
    title: 'Shipping Software Pricing Plans | ShipBae',
    description:
      'Explore flexible pricing for multi-carrier shipping software with no hidden fees. Scale your shipping as you grow.',
    keywords: 'shipping software pricing, multi-carrier pricing plans, shipping platform cost',
  },
  [ROUTES.INTEGRATIONS.BASE]: {
    title: 'Ecommerce Shipping Integrations | ShipBae',
    description:
      'Connect your ecommerce platforms to real-time multi-carrier shipping with one-click integrations for Shopify, Amazon, eBay, Walmart, and more.',
    keywords:
      'shipping integrations, ecommerce shipping software, multi-carrier integrations, marketplace shipping',
  },
  [ROUTES.INTEGRATIONS.SHOPIFY]: {
    title: 'Shopify Multi-Carrier Shipping Integration | ShipBae',
    description:
      'Connect Shopify to compare carrier rates in real time, automate label printing, and streamline fulfillment.',
    keywords: 'Shopify shipping software, Shopify carrier rates, Shopify shipping automation',
  },
  [ROUTES.INTEGRATIONS.AMAZON]: {
    title: 'Amazon Shipping Software Integration | ShipBae',
    description:
      'Automate Amazon shipping with real-time carrier comparison, label generation, and cost optimization.',
    keywords:
      'Amazon shipping software, Amazon fulfillment automation, multi-carrier Amazon shipping',
  },
  [ROUTES.INTEGRATIONS.EBAY]: {
    title: 'eBay Shipping Software & Rate Comparison | ShipBae',
    description:
      'Compare carrier rates and automate eBay label printing with powerful multi-carrier shipping software.',
    keywords: 'eBay shipping software, eBay label printing, eBay carrier comparison',
  },
  [ROUTES.INTEGRATIONS.WALMART]: {
    title: 'Walmart Marketplace Shipping Software | ShipBae',
    description:
      'Connect Walmart orders to real-time carrier rate comparison and automated shipping workflows.',
    keywords:
      'Walmart shipping software, Walmart fulfillment automation, marketplace shipping tools',
  },
  [ROUTES.INTEGRATIONS.TIKTOK]: {
    title: 'TikTok Shop Shipping Integration | ShipBae',
    description:
      'Automate TikTok Shop shipping with instant label creation and AI-powered carrier rate optimization.',
    keywords:
      'TikTok Shop shipping software, TikTok fulfillment automation, carrier rate comparison',
  },
  [ROUTES.INTEGRATIONS.TEMU]: {
    title: 'Temu Shipping Integration & Carrier Rate Comparison | ShipBae',
    description:
      'Manage Temu orders with automated label creation and real-time carrier rate comparison tools.',
    keywords: 'Temu shipping software, Temu order fulfillment, Temu carrier integration',
  },
  [ROUTES.INTEGRATIONS.SHIPSTATION]: {
    title: 'ShipStation Alternative for Advanced Carrier Management | ShipBae',
    description:
      'Upgrade from ShipStation with real-time rate comparison and AI-powered carrier optimization.',
    keywords:
      'ShipStation alternative, multi-carrier shipping software, carrier management software',
  },
  [ROUTES.PRIVACY_POLICY.BASE]: {
    title: 'Privacy Policy | ShipBae',
    description:
      'Learn how ShipBae collects, uses, and protects your information across our shipping platform.',
    keywords: 'privacy policy, data protection policy, shipping software privacy',
  },
  [ROUTES.SERVICE_TERMS.BASE]: {
    title: 'Terms of Service | ShipBae',
    description:
      "Review the terms and conditions governing use of ShipBae's shipping and carrier management platform.",
    keywords: 'terms of service, shipping software terms, user terms agreement',
  },
  [ROUTES.AGREEMENT_PAGE.BASE]: {
    title: 'User Agreement | ShipBae',
    description:
      'Read the agreement outlining rights, responsibilities, and acceptable use of the ShipBae platform.',
    keywords: 'user agreement, shipping platform agreement, service agreement',
  },
  [ROUTES.RESOURCE.BLOG]: {
    title: 'Shipping & Carrier Management Blog | ShipBae',
    description:
      'Expert guides on USPS, UPS, FedEx, AI shipping, and carrier management for ecommerce brands.',
    keywords: 'shipping blog, carrier management insights, AI in shipping',
  },
  [ROUTES.RESOURCE.RELEASES]: {
    title: 'Product Updates & Shipping Software Release Notes | ShipBae',
    description:
      'Stay up to date with new features, integrations, improvements, and shipping platform updates.',
    keywords: 'shipping software updates, product release notes, carrier platform updates',
  },
  [ROUTES.SB_DEMO.BASE]: {
    title: 'Book a Shipping Software Demo | ShipBae',
    description:
      'Schedule a live demo to explore multi-carrier shipping automation and carrier rate comparison tools.',
    keywords: 'shipping software demo, carrier management demo, multi-carrier demo',
  },
  [ROUTES.SB_DEMO.INTRO_VIDEO]: {
    title: 'Shipping Software Demo Overview | ShipBae',
    description:
      "Watch a quick overview of ShipBae's multi-carrier shipping and carrier optimization platform.",
    keywords: 'shipping software overview, platform demo video',
  },
  [ROUTES.SB_DEMO.TOPICS]: {
    title: 'Shipping Platform Demo Topics & Walkthrough | ShipBae',
    description:
      'Discover key features covered in our shipping automation and carrier management demo.',
    keywords: 'shipping automation features, carrier management tools',
  },
  [ROUTES.SB_DEMO.DEMO_PLAYER]: {
    title: 'Interactive Shipping Software Demo Player | ShipBae',
    description:
      "Explore ShipBae's interface and features through our interactive shipping software demo.",
    keywords: 'interactive shipping demo, multi-carrier platform demo',
  },
  [ROUTES.CONTACT_US.BASE]: {
    title: 'Contact Us | ShipBae',
    description:
      'Contact our team for support, partnerships, or questions about multi-carrier shipping software.',
    keywords: 'shipping software support, contact shipping platform',
  },
  [ROUTES.HELP_CENTER.BASE]: {
    title: 'Shipping Help Center & Support Resources | ShipBae',
    description:
      'Find answers to tracking, label printing, carrier management, and shipping automation questions.',
    keywords: 'shipping help center, tracking support, shipping FAQs',
  },
  [ROUTES.AUTH.LOGIN]: {
    title: 'Login | ShipBae',
    description:
      'Log in to your ShipBae account to manage shipments, compare carrier rates, print labels, and access your shipping tools.',
    keywords:
      'ShipBae login, shipping platform login, shipping software, manage shipments, carrier rates',
  },
  [ROUTES.AUTH.REGISTRATION]: {
    title: 'Create an Account | ShipBae',
    description:
      'Create a ShipBae account to access multi-carrier shipping tools, compare rates, print labels, and manage shipments in one platform.',
    keywords:
      'ShipBae registration, create account, shipping software, multi-carrier shipping, shipping platform',
  },
  [ROUTES.FREE_TOOLS.SHIPPING_CALCULATOR]: {
    title: 'Shipping Calculators | ShipBae',
    description:
      'Use ShipBae shipping calculators to estimate costs, compare rates, and better understand shipping fees before you create a label.',
    keywords:
      'shipping calculators, shipping cost calculator, rate calculator, shipping estimates, compare shipping rates, ShipBae',
  },
}
